import React, { useEffect, useState } from "react";
import "../styles/KuldeviProfile.css";
import bhrigu_logo from "../assets/images/bhrigu-logo.gif";
import image1 from "../assets/images/temple1.jpg";
import image2 from "../assets/images/idol1.jpg";
import image3 from "../assets/images/map.jpg";
import config from "../services/config";
import Loader from "../utilities/Loader";

const KuldeviDetails = ({ kuldeviId }) => {
    const [kuldeviData, setKuldeviData] = useState([]);
    const [loading, setLoading] = useState(false);
    console.log("Kuldevi ID:", kuldeviId);

    const fetchKuldeviData = async () => {
        try {
            setLoading(true);
            const payload = {
                company_id: 1,
                kuldevi_id: kuldeviId.id
            }
            // Example API calls (replace with your real ones)
            const Res = await config.getKuldeviDetailsForCustomerSide(payload);
            console.log('Res', Res)
            if (Res?.status === true) {
                setKuldeviData(Res.data);
            }
        } catch (error) {
            console.error("❌ Error fetching Gotra/Kuldevi data:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        // Dummy data (replace later with API)
        const dummyData = {
            kuldevi_name: "नागणनाथ माता",
            author: "राजीव भार्गव",
            author_bio:
                "राजीव भार्गव का जन्म 1954 में हुआ था और उन्होंने दिल्ली और अंतरराष्ट्रीय में शिक्षा प्राप्त की। वे अंग्लिंग में शिक्षाविद समाज में कार्यरत हैं। वे दिल्ली के मानव विकास केंद्र और भारतीय विकास संस्थान के निदेशक रहे।",
            description: `"नागण फुसन" संभवतः नागणेची माता (या नागणेच्या मां) के 
लिए एक गलत वर्तनी है, जो राठौड़ वंश की कुलदेवी हैं। वे मारवाड़ 
और बीकानेर राज्यों की कुलदेवी हैं और उनका मुख्य मंदिर राजस्थान 
के जोधपुर के पास नगाणा गाँव में है। 
कुलदेवी का नाम: नागणेची माता, जिन्हें नागणेच्या मां भी कहा जाता है।
कुल: राठौड़ वंश, विशेष रूप से मारवाड़ और बीकानेर के राठौड़।
मुख्य मंदिर: नगाणा गाँव, जोधपुर, राजस्थान।
इतिहास: किंवदंतियों के अनुसार, राव शिओजी के पोते राव दूहड़ ने 
कन्नौज से लौटने के बाद बाड़मेर जिले में इस मंदिर की स्थापना की थी। 
"नागण फुसन" संभवतः नागणेची माता (या नागणेच्या मां) के 
लिए एक गलत वर्तनी है, जो राठौड़ वंश की कुलदेवी हैं। वे मारवाड़ 
और बीकानेर राज्यों की कुलदेवी हैं और उनका मुख्य मंदिर राजस्थान 
के जोधपुर के पास नगाणा गाँव में है। 
कुलदेवी का नाम: नागणेची माता, जिन्हें नागणेच्या मां भी कहा जाता है।
कुल: राठौड़ वंश, विशेष रूप से मारवाड़ और बीकानेर के राठौड़।
मुख्य मंदिर: नगाणा गाँव, जोधपुर, राजस्थान।
इतिहास: किंवदंतियों के अनुसार, राव शिओजी के पोते राव दूहड़ ने 
कन्नौज से लौटने के बाद बाड़मेर जिले में इस मंदिर की स्थापना की थी।`,
            temple_name: `"नागण फुसन" संभवतः नागणेची माता (या नागणेच्या मां) के 
लिए एक गलत वर्तनी है, जो राठौड़ वंश की कुलदेवी हैं। वे मारवाड़ 
और बीकानेर राज्यों की कुलदेवी हैं और उनका मुख्य मंदिर राजस्थान 
के जोधपुर के पास नगाणा गाँव में है। "`,
            images: [
                image1,
                image2,
                image3,
            ],
        };
        fetchKuldeviData()
        // setKuldeviData(dummyData);
    }, [kuldeviId]);

    if (!kuldeviData) return <div> {loading && <Loader />}</div>;

    return (
        //         <div className="kuldevi-profile-container">
        //             {loading && <Loader />}
        //             {/* Left Section (Logo & Title) */}
        //             <div className="kuldevi-left">
        //                 <div className="kuldevi-logo">
        //                     <img src={bhrigu_logo} alt="bhrigu lineage" />
        //                     {/* <h2 className="title-lineage">bhrigu<br />lineage</h2> */}
        //                 </div>
        //                 <div className="kuldevi-label">कुलदेवी</div>
        //                 <h1 className="kuldevi-name">{kuldeviData.kuldevi_name}</h1>
        //             </div>

        //             {/* Middle Section (Author & Info) */}
        //             <div className="kuldevi-middle">
        //                 <div className="kuldevi-author">
        //                     <div className="midsection">
        //                         <div className="profilesview">
        //                             <div className="profile-pic-placeholder">{kuldeviData.profile_image} </div>
        //                             <h3>{kuldeviData.author_name}</h3>
        //                             <p className="author-bio">{kuldeviData.auther_about}</p>
        //                         </div>
        //                         <div className="profilesdescription">
        //                             <p className="kuldevi-description">{kuldeviData.kuldevi_blogges}</p>
        //                             {/* <p className="kuldevi-temple">{kuldeviData.temple_name}</p>         */}
        //                         </div>
        //                     </div>
        //                 </div>
        //                 <div className="kuldevi-images">
        //                     {kuldeviData?.photos?.map((photo, index) => (
        //                         <img
        //                             key={photo.id || index}
        //                             src={`${config.baseUrl}/${photo.image_path}`} // 👈 prepend your base URL
        //                             alt={`kuldevi-${index}`}
        //                             className="kuldevi-photo"
        //                         />
        //                     ))}
        //                 </div>
        //             </div>

        //             {/* Right Section (Description + Images) */}
        //             <div className="kuldevi-right">
        //                 {/*         
        //         <p>"नागण फुसन" संभवतः नागणेची माता (या नागणेच्या मां) के 
        // लिए एक गलत वर्तनी है, जो राठौड़ वंश की कुलदेवी हैं। वे मारवाड़ 
        // और बीकानेर राज्यों की कुलदेवी हैं और उनका मुख्य मंदिर राजस्थान 
        // के जोधपुर के पास नगाणा गाँव में है। 
        // कुलदेवी का नाम: नागणेची माता, जिन्हें नागणेच्या मां भी कहा जाता है।
        // कुल: राठौड़ वंश, विशेष रूप से मारवाड़ और बीकानेर के राठौड़।
        // मुख्य मंदिर: नगाणा गाँव, जोधपुर, राजस्थान।
        // इतिहास: किंवदंतियों के अनुसार, राव शिओजी के पोते राव दूहड़ ने 
        // कन्नौज से लौटने के बाद बाड़मेर जिले में इस मंदिर की स्थापना की थी। 
        // "नागण फुसन" संभवतः नागणेची माता (या नागणेच्या मां) के 
        // लिए एक गलत वर्तनी है, जो राठौड़ वंश की कुलदेवी हैं। वे मारवाड़ 
        // और बीकानेर राज्यों की कुलदेवी हैं और उनका मुख्य मंदिर राजस्थान 
        // के जोधपुर के पास नगाणा गाँव में है। 
        // कुलदेवी का नाम: नागणेची माता, जिन्हें नागणेच्या मां भी कहा जाता है।
        // कुल: राठौड़ वंश, विशेष रूप से मारवाड़ और बीकानेर के राठौड़।
        // मुख्य मंदिर: नगाणा गाँव, जोधपुर, राजस्थान।
        // इतिहास: किंवदंतियों के अनुसार, राव शिओजी के पोते राव दूहड़ ने 
        // कन्नौज से लौटने के बाद बाड़मेर जिले में इस मंदिर की स्थापना की थी। </p>

        // <p>"नागण फुसन" संभवतः नागणेची माता (या नागणेच्या मां) के 
        // लिए एक गलत वर्तनी है, जो राठौड़ वंश की कुलदेवी हैं। वे मारवाड़ 
        // और बीकानेर राज्यों की कुलदेवी हैं और उनका मुख्य मंदिर राजस्थान 
        // के जोधपुर के पास नगाणा गाँव में है। 
        // कुलदेवी का नाम: नागणेची माता, जिन्हें नागणेच्या मां भी कहा जाता है।
        // कुल: राठौड़ वंश, विशेष रूप से मारवाड़ और बीकानेर के राठौड़।
        // मुख्य मंदिर: नगाणा गाँव, जोधपुर, राजस्थान।
        // इतिहास: किंवदंतियों के अनुसार, राव शिओजी के पोते राव दूहड़ ने 
        // कन्नौज से लौटने के बाद बाड़मेर जिले में इस मंदिर की स्थापना की थी। 
        // "नागण फुसन" संभवतः नागणेची माता (या नागणेच्या मां) के 
        // लिए एक गलत वर्तनी है, जो राठौड़ वंश की कुलदेवी हैं। वे मारवाड़ 
        // और बीकानेर राज्यों की कुलदेवी हैं और उनका मुख्य मंदिर राजस्थान 
        // के जोधपुर के पास नगाणा गाँव में है। </p> */}
        //             </div>
        //         </div>
        // 
        <div className="kuldevi-profile-container">
            {loading && <Loader />}
            {/* Left Section (Logo & Title) */}
            <div className="kuldevi-left">
                <div className="innerkuldevileftpanel">
                    <div className="kuldevi-logo">
                        <img src={bhrigu_logo} alt="bhrigu lineage" />
                    </div>
                    <div className="kuldevi-label">कुलदेवी</div>
                    <h1 className="kuldevi-name">
                        {kuldeviId.hindi_name ? kuldeviId.hindi_name : kuldeviId.name}
                    </h1>
                </div>
            </div>

            {/* Middle Section (Author & Info) */}
            <div className="kuldevi-middle">
                <div className="kuldevi-author">
                    {kuldeviData.map((item, index) => (
                        <div key={index} className="midsection">
                            <div className="profilesview">
                                <div className="profile-pic-placeholder">
                                    {item.profile_image ? (
                                        <img
                                            src={item.profile_image}
                                            alt={item.kuldevi_name}
                                            className="profile-img"
                                        />
                                    ) : (
                                        "No Image"
                                    )}
                                </div>
                                <h3>{item.author_name}</h3>
                                <p className="author-bio">{item.auther_about}</p>
                            </div>

                            <div className="profilesdescription">
                                <p
                                    className="kuldevi-description"
                                    dangerouslySetInnerHTML={{ __html: item.kuldevi_blogges }}
                                ></p>
                            </div>

                            <div className="kuldevi-images">
                                {item.photos?.map((photo, i) => (
                                    <img
                                        key={photo.id || i}
                                        src={photo.base64_image}
                                        alt={`kuldevi-${i}`}
                                    />
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Right Section (empty placeholder) */}
            <div className="farright"></div>
        </div>




    );
};

export default KuldeviDetails;
